<template>
<div>
  <Modal
    v-model="isShow"
    :width="900"
    :loading="loading"
    :mask-closable="false"
  >
    <h3 slot="header" class="modal-header">修改运营标签</h3>
    <Form
			ref="addData"
			:model="addData"
			:rules="ruleValidate2"
			:label-width="160">
      <Row >
				<Col span="10">
					<FormItem prop="labelName" label="标签名称">
						<Input v-model="addData.labelName" placeholder="请输入标签名称"></Input>
					</FormItem>
				</Col>
				<Col span="10">
					<FormItem prop="labelOrder" label="显示顺序">
						<Input v-model="addData.labelOrder" placeholder="请输入大于0的整数"></Input>
					</FormItem>
				</Col>
      </Row>
			<Row>
				<Col span="10">
					<FormItem prop="remark" label="描述">
						<Input v-model="addData.remark" placeholder="请输入不超过20个字"></Input>
					</FormItem>
				</Col>
        <Col span="10">
          <FormItem prop="attachmentImgUrl" label="背景图片">
						<div class="imgBox">
            <Col style="float:left" v-if="addData.attachmentImgUrl">
              <img class="upload" :src="addData.attachmentImgUrl">
              <Button size="small" style="margin:16px 8px 0;float:left" @click="deleteImg">删除</Button>
            </Col>
           <Upload
						:class="['upload',{error: !addData.attachmentImgUrl}]"
            :action="baseUrl+'/file/uploadFile'"
            :on-success="handleSuccess"
            :headers="{'Access-Token':token}"
            :show-upload-list="false"
            :on-error="handleError"
            :format="['jpg','jpeg','png']"
            :on-format-error="formatError"
            icon="ios-cloud-upload-outline"
           >
           <Icon :class="{error_plus_icon: !addData.attachmentImgUrl}" type="ios-plus-empty" size="30" style="vertical-align: middle"></Icon>
          </Upload>
					</div>
					<p v-if="!addData.attachmentImgUrl" class="error_msg">请上传背景图</p>
          </FormItem>
        </Col>

      </Row>
      <Row>
				<Col span="10">
					<FormItem prop="labelSecondaryType"  label="标签类型">
						<Select v-model="addData.labelSecondaryType"  placeholder="请选择">
							<Option value="">请选择</Option>
							<Option v-for="item in secondaryYYType" :key="item.value+'keyYY'" :value="item.value">{{item.text}}</Option>
						</Select>
					</FormItem>
				</Col>
        <Col span="10">
          <FormItem prop="link" label="跳转链接">
						<Input v-model="addData.link"></Input>
          </FormItem>
        </Col>
				<Col span="10">
          <FormItem prop="highLight" label="是否高亮">
            <i-switch v-model="addData.highLight">
								<span slot="open">是</span>
								<span slot="close">否</span>
						</i-switch>
          </FormItem>
        </Col>
				<Col span="10" v-if="addData.labelSecondaryType === 7">
          <FormItem prop="couponLabel" label="是否为优惠券活动">
            <i-switch v-model="addData.couponLabel">
								<span slot="open">是</span>
								<span slot="close">否</span>
						</i-switch>
          </FormItem>
        </Col>
      </Row>
			<Row class="max64">
				<Col span="10">
					<FormItem prop="labelShowPosition" label="标签展示位置：">
						<Checkbox-group v-model="addData.labelShowPosition">
								<Checkbox label="1">项目</Checkbox>
								<Checkbox label="2">房型</Checkbox>
						</Checkbox-group>
					</FormItem>
				</Col>
			</Row>
      <Row class="max64">
        <Col span="10">
          <FormItem prop="projectFids" label="适用项目" v-if="addData.labelShowPosition.length > 0">
            <Select v-model="addData.projectFids" placeholder="请选择" multiple filterable @on-change="selectProject">
							<Option value="all">全部选择</Option>
							<Option v-for="(item,index) in projects" :key="'s4'+index" :value="item.value">{{item.text}}</Option>
						</Select>
          <span class="count" v-if="addData.projectFids.length">{{addData.projectFids.length}}</span>
          </FormItem>
        </Col>
				<Col span="10">
          <FormItem prop="houseTypeFids" label="适用房型"  v-if="addData.labelShowPosition.indexOf('2')!==-1">
            <Select v-model="addData.houseTypeFids" placeholder="请选择" multiple filterable @on-change="selectHouse">
							<Option value="all">全部选择</Option>
							<Option v-for="(item,index) in houseTypes" :key="'s4'+index" :value="item.value">{{item.text}}</Option>
						</Select>
          <span class="count" v-if="addData.houseTypeFids.length">{{addData.houseTypeFids.length}}</span>
          </FormItem>
        </Col>
				<!-- <Col span="10">
          <FormItem prop="syncHousetype" label="标签是否同步在房型展示">
            <i-switch v-model="addData.syncHousetype">
								<span slot="open">是</span>
								<span slot="close">否</span>
						</i-switch>
          </FormItem>
        </Col> -->
      </Row>
		</Form>
		<div slot="footer">
      <Button type="text" size="large" @click="handleCancel">取消</Button>
      <Button type="primary" size="large" @click="ok">
        <span>保存</span>
      </Button>
    </div>
  </Modal>
	<Modal
		class="mask"
		v-model="isModalShow"
    :width="400"
    :loading="loading"
    :mask-closable="false"
		@on-ok="save"
    @on-cancel="cancel"
	>
		<h3 slot="header" class="modal-header">消息提醒</h3>
		<div class="tip">{{tips}}</div>
	</Modal>
	</div>
</template>


<script>
import {getToken} from "utils/auth";
import {getBaseUrl} from "utils/public";
import {saveOrEdit,toEditLabel,getHoseTypeInfoListByProId} from 'api/labelmanage'

export default {
	props:{
		n:{
			type:Number,
			default:0
		},
		secondaryType:{
			type:Array,
			default(){
        return []
      }
		},
		secondaryYYType:{
			type:Array,
			default(){
				return []
			}

		},
		applyObject:{
			type:Array,
			default(){
        return []
      }
		},
		// houseTypes:{
		// 	type:Array,
		// 	default(){
    //     return []
    //   }
		// },
		projects:{
			type:Array,
			default(){
        return []
      }
		},
		labelFid:{
			type:String,
			default:''
		}
	},
  data(){
		const validates = (rule, value, callback) => {
			const pattern = /^\+?[1-9]\d*$/
			if (!pattern.test(value)) {
				callback(new Error('请填写显示顺序且为大于0的整数'));
			} else {
				callback();
			}
		};
		return{
			ruleValidate2:{
				labelName:[
          { required: true, message: '请输入标签名', trigger: 'blur',type:'string'}
				],
        labelOrder:[
          { required: true, message: '请输入大于0的整数', trigger: 'blur',type:'number',validator: validates}
				],
				remark:[
          { required: true, message: '请输入不超过20个字的描述', max:20, trigger: 'blur',type:'string'}
				],
				attachmentImgUrl:[
					{ required: true, message: ' '}
				],
				projectFids:[
					{ required: true, message: '请选择适用项目', trigger: 'change',type:'array'}
				],
				houseTypeFids:[
					{ required: true, message: '请选择房型', trigger: 'change',type:'array'}
				],
				labelSecondaryType:[
					{ required: true, message: '请选择标签类型', trigger: 'blur',type:'number',}
				],
				labelShowPosition: [
					{ required: true, message: '请选择标签展示位置', trigger: 'change',type:'array'}
				]
			},
			token:'',
      baseUrl:'',
			loading:false,
			isShow:false,
			addData:{
				projectFids:[],
				houseTypeFids:[],
				labelShowPosition:[]
			},
			isModalShow:false,
			tips:'提交后标签将在页面上显示！',
			itemP:[],
			labelEntities:[],
			maxnum:1,
			imgIndex:0,
			selectedAll:false,
			selectedAll2:false,
			houseTypes:[]
		}
	},
	created() {
    this.baseUrl = getBaseUrl()
    this.token = getToken()
  },
	watch:{
		n(){
			this.$refs['addData'].resetFields()
			this.getDetail();
			this.isShow = true;
		}
	},
	methods:{
		getDetail(){
			toEditLabel({labelFid:this.labelFid})
			.then(res=>{
				this.addData = res.data;
				this.addData.highLight = this.addData.highLight===1?true:false
				this.addData.couponLabel = this.addData.couponLabel === 1?true:false
				this.addData.syncHousetype = this.addData.syncHousetype===1?true:false
				this.getHouseProject();
				if(this.addData.projectFids.length===this.projects.length){
					this.selectedAll = true
				} else{
					this.selectedAll = false
				}
				if(this.addData.houseTypeFids.length===this.houseTypes.length){
					this.selectedAll2 = true
				} else{
					this.selectedAll2 = false
				}
				switch (this.addData.applyType){
					case 1:
						this.$set(this.addData,'labelShowPosition',['1'])
						break;
					case 2:
						this.$set(this.addData,'labelShowPosition',['2'])
						break;
					case 3:
						this.$set(this.addData,'labelShowPosition',['1','2'])
						break;
					default:
						this.addData.labelShowPosition = []
						break;
				}
			})
		},
		selectProject(value){
			let isCheck = false
			value.forEach(ele=>{
				if(ele==='all'){
					isCheck = true
					this.selectedAll = !this.selectedAll
				}
			})
			if(isCheck&&this.selectedAll){
				const val = []
				this.projects.forEach(ele=>{
					val.push(ele.value)
				})
				this.addData.projectFids = val;
			}
			if(isCheck && !this.selectedAll){
				this.addData.projectFids = []
			}
			if(this.addData.labelShowPosition.indexOf('2')!==-1)
			this.getHouseProject();
		},
		getHouseProject(){
			getHoseTypeInfoListByProId({
				projectIds:this.addData.projectFids
			}).then(res => {
				console.log(res)
				this.houseTypes = res.data.houseTypes;
			})
		},
		selectHouse(value){
			let isCheck = false
			value.forEach(ele=>{
				if(ele==='all'){
					isCheck = true
					this.selectedAll2 = !this.selectedAll2
				}
			})
			if(isCheck&&this.selectedAll2){
				const val = []
				this.houseTypes.forEach(ele=>{
					val.push(ele.value)
				})
				this.addData.houseTypeFids = val;
			}
			if(isCheck && !this.selectedAll2){
				this.addData.houseTypeFids = []
			}
		},
		deleteImg(){
			this.addData.attachmentImgUrl = ''
			this.addData.attachmentFid = ''
    },
		handleSuccess(res){
			if(this.addData.attachmentImgUrl){
				this.$Message.error('最多上传'+this.maxnum+'张图片')
				this.changeLoading();
				return
			}
			this.addData.attachmentImgUrl = res.data.url;
			this.addData.attachmentFid = res.data.fid;//图片fid
		},
		formatError(){
      this.$Message.info('请上传jpg、jpeg、png类型文件')
    },
		handleError(){
			return
    },
		ok(){
      let validate = true
      this.$refs['addData'].validate( bool => {
        if(bool && this.addData.attachmentImgUrl){
					this.isModalShow = true
        } else{
          validate = false
          this.changeLoading();
        }
      })
      if (!validate) {
        this.changeLoading()
        return
			}
			this.isModalShow = true
    },
		save(){
			const labelEntities = [{
				fid:this.labelFid,
				labelType:5,
				labelName:this.addData.labelName,
				labelOrder:this.addData.labelOrder,
				link:this.addData.link,
				remark:this.addData.remark,
				highLight:this.addData.highLight===true?1:0,
				couponLabel:this.addData.couponLabel===true?1:0,
				labelSecondaryType:this.addData.labelSecondaryType,
				picUrl:[
					{
						fid:this.addData.attachmentFid,
						attachmentImgUrl:this.addData.attachmentImgUrl
					}
				]
			}]
			// applyType 1：项目 2 房型 3：项目+房型 4：房间
			let applyType;
			if(this.addData.labelShowPosition.indexOf('2')!==-1){
				if(this.addData.labelShowPosition.length > 1){
					applyType = 3
				} else{
					applyType = 2
				}
			} else {
				applyType = 1
			}
			const params = {
				applyType:applyType,
				labelEntities:labelEntities,
				syncHousetype:this.addData.syncHousetype===true?1:0,
				projectFids:this.addData.projectFids,
				houseTypeFids: this.addData.houseTypeFids,
				projectHouseTypeFids: this.addData.projectFids
			}
			saveOrEdit(params)
			.then(res=>{
				if(res.code === 0){
					this.$emit('done')
					this.$Message.success('保存成功')
				} else{
					// this.$Message.error('保存失败')
				}
			})
			.catch(()=>{
				return
				// this.$Message.error('保存失败')
			})
			.finally(()=>{
				this.isModalShow = false
				this.isShow = false;
			})
		},
		cancel(){
			this.isModalShow = false
		},
		handleCancel(){
			this.isShow = false;
		},
		changeLoading(){
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true
      })
    },
	}
}
</script>
<style scoped>
	.imgBox{
		width: 100%;
    height: 40px;
	}
	.error_msg{
		width: 90px;
		height: 0;
		line-height: 18px;
		color: #F56356;
	}
	.error_plus_icon{
		color: #F56356
	}
	.error {
    border-color: #F56356!important;
  }
	.tip{
		font-size: 13px;
		text-align: center;
	}
.upload {
    display: block;
		float: left;
    width: 60px;
    height: 40px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
		line-height: 40px;
  }
	.repeatForm{
		padding-top: 24px;
		width: 100%;
		height: auto;
		border: 1px dashed darkgrey;
		margin-bottom: 20px;
	}
	.count {
    display: inline-block;
    min-width: 16px;
    min-height: 16px;
    position: absolute;
    top: -6px;
    right: -6px;
    background: #cfa868;
    color: #ffffff;
    border-radius: 100%;
    line-height: 15px;
    text-align: center;
    font-weight: 600;
  }

</style>
